import { HeaderColumn } from '@tableau/widgets-datagrid';
import * as React from 'react';

export class GeocodingRecordActionHeaderFormatter extends React.Component<HeaderColumn.HeaderFormatterProps, {}> {
  public constructor(props: HeaderColumn.HeaderFormatterProps) {
    super(props);
    this.state = {};
  }

  public render(): JSX.Element {
    const props: React.HTMLAttributes<HTMLDivElement> = {
      style: { textAlign: 'center' },
    };
    return (
      <div {...props}>
        {this.props.col.name}
      </div>
    );
  }
}
